function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ag {\n                fill: #fff;\n                stroke-width: 3px;\n            }\n\n            .ag,\n            .bg {\n                stroke: #afafaf;\n            }\n\n            .bg,\n            .dg {\n                fill: none;\n            }\n\n            .bg {\n                stroke-linecap: round;\n                stroke-linejoin: round;\n            }\n\n            .cg {\n                stroke: none;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-281 -500)"
}, /*#__PURE__*/React.createElement("g", {
  className: "ag",
  transform: "translate(284 503)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cg",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("circle", {
  className: "dg",
  cx: 15,
  cy: 15,
  r: 16.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(291.776 510.665)"
}, /*#__PURE__*/React.createElement("path", {
  className: "bg",
  d: "M1.5,1.5,12.949,12.949"
}), /*#__PURE__*/React.createElement("path", {
  className: "bg",
  d: "M11.908,13.867H2.541A1.041,1.041,0,0,1,1.5,12.826V7.1A1.041,1.041,0,0,1,2.541,6.061H4.1M5.663,4.5H8.786L9.826,6.061h2.082A1.041,1.041,0,0,1,12.949,7.1v4.861M8.931,10.89A2.082,2.082,0,1,1,6.038,8",
  transform: "translate(0 -1.959)"
})));

function SvgUserStreamPlaceholderV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStreamPlaceholderV2);
export default __webpack_public_path__ + "static/media/user_stream_placeholder_v2.ebbd7c73.svg";
export { ForwardRef as ReactComponent };